<template>
  <!-- Feature Sections > With product screenshot on dark -->
  <div id="studio" class="overflow-hidden bg-gray-900 py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto grid max-w-2xl grid-cols-1 gap-y-16 gap-x-8 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
        <div class="lg:pr-8 lg:pt-4">
          <div class="lg:max-w-lg">
            <h2 class="text-lg font-semibold leading-8 tracking-tight text-teal-500">
              St. Audio Studio
            </h2>
            <p class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Dein Wegweiser für Podcast-Wachstum
            </p>
            <p class="mt-6 text-lg leading-8 text-gray-300">
              Bestimme deine Meilensteine und lerne, mit welchem Methoden-Mix du diese schnellstmöglich erreichst. Immer wieder. Möglich machen das diese drei Bestandteile:
            </p>
            <dl class="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-300 lg:max-w-none">
              <div v-for="part in parts" :key="part.name" class="relative pl-9">
                <dt class="inline font-semibold text-white">
                  <component :is="part.icon" class="absolute top-1 left-1 h-5 w-5 text-teal-500" aria-hidden="true" />
                  {{ part.name }}
                </dt>
                {{ ' ' }}
                <dd class="inline">{{ part.description }}</dd>
              </div>
            </dl>
          </div>
        </div>
        <img src="/images/index-2.png" alt="Features, die du lieben wirst" class="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-white/10 sm:w-[57rem] md:-ml-4 lg:-ml-0" width="2960" height="1804" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { RectangleStackIcon } from '@heroicons/vue/24/solid';
import { MicrophoneIcon } from '@heroicons/vue/20/solid';
import { BeakerIcon } from '@heroicons/vue/20/solid';

const parts = [
  {
    name: 'Reichweiten-Methoden:',
    description: 'Die größte Sammlung an Wachstumstipps in und um deinen Podcast – umfassend beschrieben und mit Schritt-für-Schritt-Anleitungen.',
    icon: RectangleStackIcon,
  },
  {
    name: 'Smarter KI-Assistent:',
    description: 'Dein Kompass lernt fortlaufend, mit welchem Methoden-Mix ähnliche Podcasts erfolgreich waren und teilt das Wissen mit dir.',
    icon: MicrophoneIcon,
  },
  {
    name: 'Experimentierkasten:',
    description: 'Bringt dich in die Umsetzung von Wachstumsideen und analysiert deine Ergebnisse. Bleib dran – oder probiere eine neue Methoden aus.',
    icon: BeakerIcon,
  },
];
</script>
